import "./index.scss"
import React, { useEffect, useState } from "react"
import SquareMapUsa from "./SquareMapUsa";

const ResultsList = ({selectedArea, filteredResult}) => (
  <div className="map-section__results-list">
    {
      selectedArea === 'All Areas'
      ?
      filteredResult[0]?.data?.map(issue => {
        return (
            issue?.data?.length > 0 &&
            <>
              <h6 className="results-list__title">{issue.issue}</h6>
              {issue?.data?.map(law => <LegistationContent 
                key={law.headline}
                issue={law.issue}
                title={law.headline} 
                description={law.description} 
                legalReferences={law['legal references']} 
              />)}
            </>
        )
      })
      :
      filteredResult[0]?.data?.map(law => <LegistationContent 
        key={law.headline}
        issue={law.issue}
        title={law.headline} 
        description={law.description} 
        legalReferences={law['legal references']} 
      />)
    }
  </div>
)

const LegistationContent = ({title, description, legalReferences}) => (
  <>
    <div className="result">
      <h6 className="result__title">{title}</h6>
      <p className="result__text">{description}</p>
      {
        legalReferences?.map(reference => 
          <a 
            key={reference.link}
            rel="noreferrer noopener" 
            target="_blank" 
            className="result__law" 
            href={reference.link}
          >
              {reference.text}
          </a>
        )
      }
    </div>
  </>
)

export default function StateInterferenceMap({ component }) {
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [filteredLaws, setFilteredLaws] = useState([]);
  const [statesWithLaw, setStatesWithLaw] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedArea, setSelectedArea] = useState('All Areas');

  useEffect(() => {
    const {interferenceData} = component;
    const parsedData = JSON.parse(interferenceData);
    setInitialData(parsedData)

    const issues = [...new Set(parsedData.map(item => item.issue))];
    const states = [...new Set(parsedData.map(item => item.state))];

    const statesData = states.map(state => ({
      state,
      data: parsedData.filter(data => data.state === state)
    }))

    const formatedStatesData = statesData.map(state => ({
      state: state.state,
      data: issues.map(issue => ({
          issue,
          data: state.data.filter(data => data.issue === issue)
        }))
    }))

    setData(formatedStatesData)
  }, [])

  useEffect(() => {
    setFilteredLaws([])
    if(selectedArea === 'All Areas') {
      setStatesWithLaw([]);

      selectedState === '' ?
        setFilteredLaws([])
      :
        setFilteredLaws(data?.filter(item => item['state'] === selectedState))
    } else if(selectedArea !== 'All Areas' && selectedState === '') {
      setFilteredLaws([])
    } else {
      setFilteredLaws(data?.filter(item => item['state'] === selectedState)[0]?.data?.filter(data => data.issue === selectedArea))
    }
  }, [selectedState])

  useEffect(() => {
    setFilteredLaws([])
    if(selectedArea === 'All Areas' && !selectedState) {
      setFilteredLaws([]);
      setStatesWithLaw([])
    } else if (selectedArea === 'All Areas' && selectedState) {
      setStatesWithLaw([])
      setFilteredLaws(data?.filter(item => item['state'] === selectedState));
    } else {
      setStatesWithLaw([...new Set(initialData.filter(item => item['issue'] === selectedArea).map(item => item.state))])

      selectedState &&
      setFilteredLaws(data?.filter(item => item['state'] === selectedState)[0]?.data?.filter(data => data.issue === selectedArea))      
    }
  }, [selectedArea])

  const handleClick = () => {
    setFilteredLaws([]);
    setSelectedArea('All Areas');
  }
  
  return (
    <section className="map-container">
      <div className="container">

        <div className="row">
          <div className="col-md-12">
            <h3 className="map-section__headline oblique">Tracking State Interference</h3>
          </div>
        </div>

        {
          data  
            &&
          <div className="row">
            <div className="col-md-6">
              <form className="map-section__form" action="">
                <div className="input-wrapper">
                  <label className="map-section__label oblique" htmlFor="legistation-area">Interference Legislation by Area</label>
                  <select value={selectedArea} className="map-section__select" onChange={(e) => setSelectedArea(e.target.value)} name="legistation-area" id="legistation-area">
                    <option className="map-section__option" value="All Areas">All Areas</option>
                    {
                      [...new Set(initialData.map(item => item.issue))].map(issue => (
                        <option className="map-section__option" value={issue}>{issue}</option >
                      ))
                    }
                  </select>
                </div>
              </form>
              <div className="map-section__notification">
                {
                  selectedArea !== 'All Areas' &&
                  <>
                    <p><b>{statesWithLaw.length} States have interference legislation around {selectedArea}.</b></p>
                    <p>Click on a state below for details</p>
                  </>
                }
              </div>
              <SquareMapUsa statesWithLaw={statesWithLaw} selectedState={selectedState} setSelectedState={setSelectedState}/>
            </div>
            {
              selectedState && filteredLaws?.length > 0 &&
              <div className="col-md-5 offset-md-1 results-wrapper">
                <h4 className="map-section__results-headline oblique">Interference Legistation {selectedArea && `on ${selectedArea.replace('-', ' ')}`} {selectedState && `in ${selectedState}`}</h4>
                {
                  selectedArea !== 'All Areas' &&
                  <p onClick={() => handleClick()} className="map-section__all-areas oblique">View all interferance legislation for this state</p>
                }
                <ResultsList selectedArea={selectedArea} filteredResult={filteredLaws}/>
              </div>
            }

          </div>
        }

      </div>
    </section>
  )
}
